import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, partnersActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, partnersActions);

export default slice.reducer;
